import React from 'react'
import PropTypes from 'prop-types'
import {AspectRatio, Box, Flex, Img, Text, useStyleConfig} from '@chakra-ui/react'
import {EditorialVideo} from '../video'
import {remCalc} from '../../../theme/_utils'
import useDamImage from '../../../custom-hooks/use-dam-image'
import ProductCatalogSlider from './partials/product-catalog-slider'

export const ShopTheLook = ({
    hasPaddings,
    maxWidth = remCalc(1920),
    isVideo,
    video,
    image,
    textBlock,
    categorySfcc,
}) => {
    const styles = useStyleConfig('ShopTheLook')
    const damImage = useDamImage(image)

    return (
        <Box
            data-testid="shop-the-look"
            {...styles.main}
            maxW={maxWidth}
            my={hasPaddings ? remCalc(24) : 0}
        >
            <Flex {...styles.container} direction={{base: 'column', xl: 'row'}}>
                <Box {...styles.imageContainer}>
                    {isVideo ? (
                        <EditorialVideo data={video} />
                    ) : (
                        (damImage.url || image?.alt) && (
                            <AspectRatio {...styles.image} ratio={damImage.ratio}>
                                <Img src={damImage.url} alt={image?.alt || ''} />
                            </AspectRatio>
                        )
                    )}
                </Box>
                <Flex direction={'column'} {...styles.productsContainer}>
                    {textBlock && (
                        <Flex direction={'column'} {...styles.textblockContainer}>
                            {textBlock?.label && (
                                <Text
                                    textStyle={'body-small'}
                                    fontWeight={'bold'}
                                    {...styles.label}
                                >
                                    {textBlock.label}
                                </Text>
                            )}
                            {textBlock?.title && (
                                <Text textStyle={'head-large'} fontWeight={'medium'}>
                                    {textBlock.title}
                                </Text>
                            )}
                            {textBlock?.bodyCopy && (
                                <Text textStyle={'body-large'} fontWeight={'normal'}>
                                    {textBlock.bodyCopy}
                                </Text>
                            )}
                        </Flex>
                    )}
                    {categorySfcc && <ProductCatalogSlider categorySfcc={categorySfcc} />}
                </Flex>
            </Flex>
        </Box>
    )
}

ShopTheLook.propTypes = {
    hasPaddings: PropTypes.bool,
    maxWidth: PropTypes.string,
    isVideo: PropTypes.bool,
    video: PropTypes.shape(),
    image: PropTypes.shape(),
    textBlock: PropTypes.shape({
        label: PropTypes.string,
        title: PropTypes.string,
        bodyCopy: PropTypes.string,
    }),
    categorySfcc: PropTypes.shape(),
}
